export const getFilterLabel = filter => {
  const label = filter.name === 'pmYear' ? 'Year' : filter.label;

  const emptinessLabel =
    filter.emptiness === 'not_empty' ? 'is not empty' : filter.emptiness === 'is_empty' ? 'is empty' : '';

  if (filter.type === 'number' && filter.operator) {
    const operatorSymbols = {
      eq: '=',
      gt: '>',
      gte: '≥',
      lt: '<',
      lte: '≤',
    };
    return `${label} ${operatorSymbols[filter.operator] || ''} ${filter.value}`;
  }

  if (filter.type === 'string' && filter.operator) {
    const operatorLabels = {
      contains: 'contains',
      startsWith: 'starts with',
      endsWith: 'ends with',
    };
    const textPart = filter.value ? `${operatorLabels[filter.operator] || ''} "${filter.value}"` : '';
    if (emptinessLabel && textPart) {
      return `${label} ${textPart} & ${emptinessLabel}`;
    }
    if (emptinessLabel) {
      return `${label} ${emptinessLabel}`;
    }
    if (textPart) {
      return `${label} ${textPart}`;
    }
  }

  if (emptinessLabel && !filter.value) {
    return `${label} ${emptinessLabel}`;
  }

  return `${label}: ${filter.value}`;
};
